import React from "react";
import Counselling from "./Counselling";

const Service4 = () => {
  return <Counselling />;
};

export default Service4;